import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated, getAuthToken, isTokenExpired, forceLogout } from "../helpers/auth-helpers";
import useTokenExpiration from "../Hooks/useTokenExpiration";

const AuthProtected = (props) => {
  // Use the token expiration hook to automatically monitor token validity
  useTokenExpiration();

  // Check if user is authenticated based on token in localStorage
  const isAuthorized = isAuthenticated();
  const token = getAuthToken();

  // Double-check token expiration on component mount
  useEffect(() => {
    if (token && isTokenExpired(token)) {
      console.log('Token expired in AuthProtected, forcing logout...');
      forceLogout();
    }
  }, [token]);

  if (!isAuthorized) {
    // Redirect non-authenticated users to login page
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render the child components
  return <>{props.children}</>;
};

export { AuthProtected };
